import store from '../store'

const minRequiredAppVersion='4.2'


export function showRepoMobileUpdateWarning() {	
	const state = store.getState()

	const mobileInfo = state.mobileInfo

	if(!mobileInfo){
		return false
	}else{
		const appVersion = mobileInfo.appVersion
		if(compareVersionNumbers(appVersion,minRequiredAppVersion)===-1){
			return true
		}else return false
	}



}



// Return 1 if a > b
// Return -1 if a < b
// Return 0 if a == b
function compareVersionNumbers(a, b) {
	if (a === b) {
			 return 0
	}

	const a_components = a.split('.')
	const b_components = b.split('.')

	const len = Math.min(a_components.length, b_components.length)

	// loop while the components are equal
	for (var i = 0; i < len; i++) {
		// A bigger than B
		if (parseInt(a_components[i],10) > parseInt(b_components[i],10)) {
			return 1
		}

		// B bigger than A
		if (parseInt(a_components[i],10) < parseInt(b_components[i],10)) {
			return -1
		}
	}

	// If one's a prefix of the other, the longer one is greater.
	if (a_components.length > b_components.length) {
		return 1
	}

	if (a_components.length < b_components.length) {
		return -1
	}

	// Otherwise they are the same.
	return 0
}